import { t } from "@/i18n-js/instance";
import { STATUS_PRESENTER } from "@circle-react/helpers/communityMemberChargeHelpers";
import { StatusBadge } from "@circle-react-uikit/StatusBadge";

interface PaywallChargeBadgeProps {
  status?: string;
}

type BadgeVariant = "success" | "warning" | "danger" | "info" | "default";

interface BadgeConfig {
  label: string;
  variant: BadgeVariant;
}

const badgeStatus: Record<string, BadgeConfig> = {
  [STATUS_PRESENTER.INCOMPLETE]: {
    label: t(
      "settings.paywalls_admin_dashboard.charges.badge_status.incomplete",
    ),
    variant: "default",
  },
  [STATUS_PRESENTER.PROCESSING]: {
    label: t(
      "settings.paywalls_admin_dashboard.charges.badge_status.processing",
    ),
    variant: "default",
  },
  [STATUS_PRESENTER.PAID]: {
    label: t("settings.paywalls_admin_dashboard.charges.badge_status.paid"),
    variant: "success",
  },
  [STATUS_PRESENTER.CANCELED]: {
    label: t("settings.paywalls_admin_dashboard.charges.badge_status.canceled"),
    variant: "default",
  },
  [STATUS_PRESENTER.PARTIAL_REFUND]: {
    label: t(
      "settings.paywalls_admin_dashboard.charges.badge_status.partial_refund",
    ),
    variant: "default",
  },
  [STATUS_PRESENTER.REFUNDED]: {
    label: t("settings.paywalls_admin_dashboard.charges.badge_status.refunded"),
    variant: "default",
  },
  [STATUS_PRESENTER.FAILED]: {
    label: t("settings.paywalls_admin_dashboard.charges.badge_status.failed"),
    variant: "danger",
  },
  unknown: {
    label: t("settings.paywalls_admin_dashboard.charges.badge_status.unknown"),
    variant: "default",
  },
};

export const PaywallChargeBadge = ({ status }: PaywallChargeBadgeProps) => {
  const badgePointer = badgeStatus[status ?? ""] ?? badgeStatus["unknown"];

  return (
    <div>
      <StatusBadge variant={badgePointer.variant}>
        {badgePointer.label}
      </StatusBadge>
    </div>
  );
};
